var _path, _path2, _path3, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9156_13260)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9156_13260",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9156_13260)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9156_13260",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9156_13260)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9156_13260",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9156_13260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.3726 18.6274 0 12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24Z",
    fill: "url(#paint0_linear_9156_13260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0273 10.1723C15.8366 10.1723 15.6819 10.3269 15.6819 10.5177V16.8247C15.6819 17.4911 15.1396 18.0335 14.4731 18.0335H6.89964C6.23315 18.0335 5.69078 17.4911 5.69078 16.8247V9.25114C5.69078 8.58466 6.23315 8.04232 6.89964 8.04232H14.4731C14.6638 8.04232 14.8185 7.88768 14.8185 7.69694C14.8185 7.5062 14.6638 7.35156 14.4731 7.35156H6.89964C5.85216 7.35156 5 8.20369 5 9.25114V16.8247C5 17.8721 5.85216 18.7242 6.89964 18.7242H14.4731C15.5205 18.7242 16.3727 17.8721 16.3727 16.8247V10.5177C16.3727 10.327 16.2181 10.1723 16.0273 10.1723Z",
    fill: "white"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9156_13260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9144 7.44451L16.5555 6.08565C16.5007 6.03081 16.4263 6 16.3487 6H11.2924C11.1309 6 11 6.13092 11 6.2924V12.7076C11 12.8691 11.1309 13 11.2924 13H17.7076C17.8691 13 18 12.8691 18 12.7076V7.65127C18 7.57373 17.9692 7.49935 17.9144 7.44451ZM16.1699 8.81253H12.1543V6.66823H16.1699V8.81253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6814 8.54728H15.4222C15.476 8.54728 15.5197 8.50364 15.5197 8.4498V7.02422C15.5197 6.9704 15.476 6.92676 15.4222 6.92676H14.6814C14.6276 6.92676 14.584 6.9704 14.584 7.02422V8.4498C14.584 8.50364 14.6276 8.54728 14.6814 8.54728Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 6.5,
    width: 6,
    height: 6,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9156_13260",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9156_13260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9156_13260"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 6,
    width: 7,
    height: 7,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveLayout);
export default __webpack_public_path__ + "static/media/save-layout.70ff8c2ab018396fa2848bb7ccfe2f62.svg";
export { ForwardRef as ReactComponent };